import React from 'react'
import {
  ChartBarIcon,
  TagIcon,
  TicketIcon,
} from '@heroicons/react/24/solid'
import AppShell from '../../../Components/AppShell'
import PageHeader from '../../../Components/PageHeader'
import ToolCard from '../../../Components/ToolCard'

const PricingToolsView = () => {
  return (
    <AppShell>
      <PageHeader
        kicker="Pricing"
        title="Pricing tools"
        subtitle="Manage promotions, deals, and brand data requests."
        crumbs={[
          { label: 'Home', to: '/home' },
          { label: 'Pricing' },
        ]}
      />
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
        <ToolCard
          title="Coupon Promotions"
          description="Create and export coupon promotion batches."
          icon={TicketIcon}
          to="/pricing-tools/coupon-promotions"
          badge="Active"
        />
        <ToolCard
          title="Amazon Deals"
          description="Deal tooling is still under development."
          icon={TagIcon}
          to="/pricing-tools/"
          badge="In development"
          badgeTone="warn"
        />
        <ToolCard
          title="Data Gathering"
          description="Filter brand data and generate downloadable files."
          icon={ChartBarIcon}
          to="/pricing-tools/data-gathering"
          badge="Backlogs"
          badgeTone="bad"
        />
      </div>
    </AppShell>
  )
}

export default PricingToolsView
